import { Http } from '../../../support';

export const initialState = {
  busy: false,
  data: {
    tipo: 'receptores',
  },
  progress: 0,
  result: undefined,
  error: undefined,
};

const onChange = (store, data) => {
  store.setState((state) => {
    state.app.receptores.upload.data = {
      ...state.app.receptores.upload.data,
      ...data,
    };
  });
};

const progress = (store, progress) => {
  store.setState((state) => {
    state.app.receptores.upload.progress = progress;
  });
};

const upload = async (store, onUploadProgress = () => {}) => {
  store.setState((state) => {
    state.app.receptores.upload.busy = true;
  });

  try {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    };

    const { data } = store.state.app.receptores.upload;

    let formData = new FormData();

    formData.append('file', data.file);
    formData.append('tipo', data.tipo);

    const response = await Http.post(`${window.BONJOUR_URL}/api/receptores/masivo`, formData, options);

    store.setState((state) => {
      state.app.receptores.upload.busy = false;
      state.app.receptores.upload.progress = 100;
      state.app.receptores.upload.result = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.receptores.upload.busy = false;
      state.app.receptores.upload.error = error.data || error;
    });
  }
};

const reset = (store, data) => {
  store.setState((state) => {
    state.app.receptores.upload = { ...initialState };
  });
};

const ReceptorUploadStore = {
  state: () => initialState,
  actions: {
    reset,
    onChange,
    progress,
    upload,
  },
};

export default ReceptorUploadStore;
